import type { IProduct, IProductToSave } from '@/types/product';
import { request } from './client';
import { generateSelectedProductsArray } from '@/components/orders/product/functions';

export function fetchProducts(params?: Record<string, string | number>): Promise<{ data: IProduct[] }> {
  return request('GET', `/v1/account/products`, params);
}
export function fetchProductTypes(params?: Record<string, string | number>): Promise<any> {
  return request('GET', `/v1/account/product-types`, params);
}

export function validateSelectedProducts(
  orderId: string | number | null | undefined,
  productsToSave: IProductToSave[]
): Promise<{ data: { valid: boolean; errors: Record<string, string[]> } }> {
  const selected_products = generateSelectedProductsArray(productsToSave);

  return request('POST', `/v1/account/order/${orderId}/validate_limits`, {}, { selected_products });
}

export function convertCurrency(amount: number, fromCurrency: string, toCurrency: string): Promise<{ amount: number }> {
  return request(
    'POST',
    `/v1/account/currency/convert`,
    {},
    { amount, source_currency: fromCurrency, target_currency: toCurrency }
  );
}
